module.exports = __webpack_public_path__ + "static/media/ABDB02.788aab55.jpg";